module.exports = __webpack_public_path__ + "static/media/gallery-3.e2347684.jpg";